import { ArrowCircleUpRight } from '@phosphor-icons/react';

export default ArrowCircleUpRight;
